export default __webpack_public_path__ + "static/media/tealbg.535bfa94.jpeg";